import { Injectable, TemplateRef } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';

import { ModalBottomsheetComponent } from './modal-bottomsheet.component';

export const defaultBottomSheetConfig = {
  backdropClass: 'modal-bottomsheet-backdrop',
  data: {},
};

export const defaultModalConfig = {
  backdropClass: 'modal-bottomsheet-backdrop',
  width: '390px',
  maxWidth: '100%',
  disableClose: false,
  data: {},
};

export enum ModalBottomsheetType {
  general = 'general',
  share = 'share',
  export = 'export',
}

@Injectable()
export class ModalBottomsheetHelper {
  constructor(private bottomSheet: MatBottomSheet, public dialog: MatDialog) {}

  openDialog(
    type: ModalBottomsheetType = ModalBottomsheetType.general,
    title: TemplateRef<never> | null | undefined,
    content: TemplateRef<never> | null | undefined,
    size: string | null | undefined,
    data: object = {},
    bottomSheetConfig: object = {},
    modalConfig: object = {},
    actions?: TemplateRef<never> | null | undefined
  ): Promise<unknown> {
    bottomSheetConfig = {
      ...defaultBottomSheetConfig,
      ...bottomSheetConfig,
      data: {
        ...data,
        type: type,
        content: content,
        title: title,
        size: size,
        actions: actions,
      },
    };

    modalConfig = {
      ...defaultModalConfig,
      ...modalConfig,
      data: {
        ...data,
        type: type,
        content: content,
        title: title,
        size: size,
        actions: actions,
      },
    };

    if (size === 'phone') {
      return firstValueFrom(this.bottomSheet.open(ModalBottomsheetComponent, bottomSheetConfig).afterDismissed());
    } else {
      return firstValueFrom(this.dialog.open(ModalBottomsheetComponent, modalConfig).afterClosed());
    }
  }

  closeDialog() {
    this.tryCloseDialog();
    this.tryCloseBottomSheet();
  }

  private tryCloseDialog() {
    const { dialog } = this;
    if (!dialog) return;
    if (dialog.openDialogs?.length === 0) return;
    try {
      dialog.openDialogs.forEach((dialogRef) => {
        dialogRef.close();
      });
    } catch (e) {
      return;
    }
  }

  private tryCloseBottomSheet() {
    if (!this.bottomSheet) return;
    const bottomSheetRef = this.bottomSheet._openedBottomSheetRef;
    if (!bottomSheetRef) return;
    try {
      bottomSheetRef.dismiss();
    } catch (e) {
      return;
    }
  }
}
